/** A VAT rate as the admin UI prints it: "19", "7", "2.50". */
export const formatRatePercent = (rate: number): string =>
    (rate % 1 === 0 ? rate.toFixed(0) : rate.toFixed(2));
